import React from "react"
import styled from "styled-components"

const StyledInput = styled.input`
  backdrop-filter: blur(40px);
  font-size: 16px;
  padding-left: 15px;
  line-height: 1.5;
  letter-spacing: 0.055em;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  box-shadow: inset 0 1px 1px 0 rgb(0 0 0 / 5%);
  background-color: #fafcfe;
  height: 39.5px;
  width: 100%;

  &:focus {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
`

const InputIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.9);
  padding-right: 5px;
  letter-spacing: 0.055em;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #082551;
  opacity: 0.5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 35px;
  width: 100%;
  margin: ${props => props.margin};
  &:focus-within {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
  span {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 50%;
  }
  input {
    background: none;
    border: none;
    height: 100%;
    &:focus-visible,
    &:focus {
      outline: none;
    }
  }
`

const Input = ({ field, icon, ...props }) => {
  delete props.form

  if (icon) {
    return (
      <InputIcon>
        <span>{icon}</span>
        <input {...field} {...props} data-cy={field?.name || props?.name} />
      </InputIcon>
    )
  } else {
    return (
      <StyledInput {...field} {...props} data-cy={field?.name || props?.name} />
    )
  }
}

export { Input }
